import { useCallback, useState, ComponentProps } from 'react';
import styled from 'styled-components';
import Heading from './heading';

const Container = styled.nav`
   position: relative;
   color: white;
   text-align: left;
   width: auto;
   margin-right: 16px;
`;

const List = styled.ul`
   display: flex;
   height: 100%;
   list-style: none;
   margin: 0;
   padding: 0;
`;

export type SublinkType = {
   disabled?: boolean;
   url: string;
   title: string;
} & ComponentProps<any>;

export type HeadingLinkType = {
   title: string;
   disabled?: boolean;
   hasStoreDropdown: boolean;
   sublinks: SublinkType[];
};

const Headings = ({ links }: { links: HeadingLinkType[] }) => {
   const [activeId, setActiveId] = useState(null);

   const headingOpened = useCallback(
      (openedId: any) => {
         setActiveId(activeId === openedId ? null : openedId);
      },
      [activeId, setActiveId]
   );

   return (
      <Container>
         <List>
            {links.map(
               (heading: HeadingLinkType) =>
                  heading.disabled || (
                     <Heading
                        key={`${heading.title}-heading`}
                        info={heading}
                        isActive={activeId === heading.title}
                        headingOpened={headingOpened}
                     />
                  )
            )}
         </List>
      </Container>
   );
};

export default Headings;
